export default {
  faq: {
    title: '常見問題',
    bookingProcess: {
      title: '訂購流程',
      q1: '如何確認是否已完成訂購呢？',
      a1: `當您預訂完成，系統將發送訂單確認信至您所登錄的E-mail信箱，煩請查收信內所附訂單資訊及憑證。如收到附有「使用電子票」連結的信件，可點擊後直接使用。
  此外，您也可以點擊信內的「訂單詳情」以確認您的訂單資訊。`,
      q2: '沒有收到訂單確認信，該怎麼辦呢？',
      a2: `當您訂購「訂購即時確認」的商品，訂單將於約5分鐘內被自動確認並發送訂單確認信至您所登錄的E-mail信箱，若超過時間仍未收到訂單確認信，煩請檢查您的垃圾信件夾內是否有來自「@linktivity.co.jp」的信件。`,
      q3: '可以重新發行憑證嗎？',
      a3: `可以，請依以下步驟重新取得憑證：

1.登入您的帳號後，點選右上角「我的主頁」→「預訂信息」。
2.在該筆訂單中點擊「查看詳情」。
3.在「憑證資訊」欄即可查看票券內容，並可點選「發送憑證」重新寄送至指定的 E-mail。`
    },
    payments: {
      title: '付款',
      q1: '付款時出現了訂購失敗的訊息，該怎麼辦呢？',
      a1: `若發生此情形請先不要馬上重新訂購，請先於右上角的「帳戶」點擊「訂單資訊」，查看訂單一覽中是否有該訂單的紀錄，或煩請查收是否有收到訂單確認信。若皆未能找到訂單紀錄，則煩請稍待約5分鐘後再重新訂購。`,
      q2: '可以給我收據嗎？',
      a2: `抱歉目前無提供線上發行收據的服務，如需收據，煩請來信至客服信箱<helpcenter@linktivity.co.jp>，並請註明您的訂單編號、收據抬頭、款項名稱、金額等資訊。`,
      q3: '可使用哪些付款方式呢？',
      a3: `您可以使用信用卡進行付款（部分商品可使用Alipay、WeChat Pay付款）。恕無法使用便利商店付款或現金付款。`,
      q4: '什麼是3D驗證？',
      a4: `3D驗證為一種身份驗證服務，可防止信用卡被盜刷等非法使用，提高持卡人在進行信用卡線上消費時的安全性。
  使用支援3D驗證的信用卡進行付款時，會要求持卡人輸入一次性密碼進行身份驗證（驗證方式依信用卡公司而異）。`,
      q5: '該如何申請3D驗證？我不知道自己的信用卡是否支援3D驗證。',
      a5: `3D驗證可在刷卡前向信用卡公司申請完成註冊手續。
  如不清楚自己的信用卡是否支援3D驗證，請洽詢卡片背面的信用卡公司客服專線。`,
      q6: `我不知道自己的3D驗證密碼。我沒收到3D驗證一次性密碼。`,
      a6: `進行3D驗證時所需的密碼為事先向信用卡公司申請3D驗證時所設定的密碼，或是一次性密碼。
  如未收到一次性密碼，請檢查您的垃圾郵件。
  如不清楚密碼或是未收到一次性密碼，請洽詢卡片背面的信用卡公司客服專線。`,
      q7: `只能使用已註冊3D驗證的信用卡嗎？`,
      a7: `因近期信用卡盜刷事件劇增，日本經濟產業省宣布預計於2025年3月下旬全面履行電子商務本人認證（EMV 3-D驗證）義務化，恕本服務僅供已註冊3D驗證的信用卡可使用，敬請諒解。
  此外，於2023年3月發布的《信用卡安全指南【4.0版】》指出，將針對電子商務業者、信用卡公司（發卡公司、加盟店管理公司）及代理付款業者，全面履行「本人認證義務化及相關應對服務」。為符合上述準則，在新的預訂平台上必須使用提供3D驗證的結帳系統。`,
      q8: '我可以使用簽帳金融卡嗎？',
      a8: `您可以使用簽帳金融卡。`,
      q9: '3D驗證及額度均沒問題、在其他網站上也可正常使用的信用卡，為什麼會一直出現錯誤，無法付款？',
      a9: `如您的信用卡沒有問題卻無法付款，代表信用卡公司的付款審批系統可能發現有未經授權的使用紀錄，並可能已取消付款以保護您的信用卡。
  此情況與人為判斷不同，電腦會預測各種因素並根據該情況做出判斷，而造成在特定時間內無法付款的可能性。
  如遇上述問題，可改嘗試下述方法。
  ・使用不同的信用卡付款。
  ・過一段時間後再度嘗試使用該信用卡付款。
  ・聯絡您的信用卡公司，說明您想訂購的票券名稱和情況，要求信用卡公司訂正詐欺偵測和付款審批系統錯誤。`,
      q10: '我已收到信用卡公司的刷卡通知，但「我的帳戶」中沒有該訂單資訊，也沒收到訂購完成的電子郵件。',
      a10: `此情形可能為以下問題。
  ・電子信箱輸入錯誤（拼字錯誤等）。
  ・訂購時輸入的電子信箱與平時使用的的電子信箱不同。
  ・付款和訂購未完成（信用卡額度沒問題，但因某些錯誤導致付款和訂購未完成）
  如您有訂購時輸入的某個電子信箱印象，請嘗試使用該信箱登入「我的帳戶」。
  如仍無法成功登入，請將下述資訊與問題發送至LINKTIVITY客服中心<helpcenter@linktivity.co.jp>  ，由我們幫您查詢您的付款和訂購記錄。
  -訂購人姓名（英文拼音）：
  -活動參加日：
  -付款日期和時間（例：3/2 19:00）：
  -付款信用卡末3碼 ：
  -付款信用卡有効期限：
  -總金額：
  -訂購時可能輸入的電子信箱：`
    },
    changesAndCancellations: {
      title: '變更與取消',
      q1: '不小心訂錯了，該怎麼取消呢？',
      a1: `若您訂購的是可以取消的商品，請登入帳號後，依以下步驟取消：
  1.請於右上角的「帳戶」點擊「訂單資訊」。
  2.請於該訂單點擊「查看詳情」。
  3.請於「取消資訊」欄確認取消政策，並點擊「開始取消」，確認取消費用後請點擊「取消」即可取消訂單。`,
      q2: '取消訂單後何時可退款呢？',
      a2: `取消訂單後，退款時間依您的信用卡公司而異，如欲確認具體的退款時間，煩請向您的信用卡公司諮詢。`,
      q3: '可以變更訂單嗎？',
      a3: `煩請先取消原本的訂單，再重新訂購。由於是否可取消以及取消政策依商品而異，請先於商品頁下方的取消政策欄確認。`
    },
    accounts: {
      title: '帳戶',
      q1: '該如何註冊帳號呢？',
      a1: `您可於網站右上角的「登入」進行註冊，或於商品頁上訂購時亦可註冊。由於近日常發生註冊帳號時輸入了錯誤E-mail的情形，註冊帳號時煩請確認是否有輸入正確的E-mail信箱。
  此外，您亦可透過Facebook或Google等帳號登入使用本服務。`,
      q2: '該如何登入呢？',
      a2: `請於訂購網站上的右上角點擊「登入」即可開始登入您的帳戶。`,
      q3: '忘記密碼了該怎麼辦呢？',
      a3: `請於登入頁面點擊「忘記密碼？」，依照頁面指示的步驟重新設定密碼。`,
      q4: '該如何刪除帳號？',
      a4: `刪除帳號方式如下：
  1.請於右上角的「帳戶」點擊「個人資訊」。
  2.請點擊右下角的「刪除帳號」即可刪除帳號。請注意，帳號刪除後即不可繼續使用本服務，如欲再次使用，煩請重新註冊。`
    },
    environment: {
      title: '網路環境',
      q1: '使用本網站時該使用什麼瀏覽器？',
      a1: `推薦使用以下瀏覽器：
  ・Firefox （最新版）
  ・Safari （最新版）
  ・Google Chrome （最新版）`,
      q2: '訂單確認信是使用什麼域名的信箱發送的呢？',
      a2: `本服務的信箱域名為「@linktivity.co.jp」，如有為預防垃圾郵件而設置電子郵件的網域限制，請於訂購前事先將「@linktivity.co.jp」加入許可清單。`
    },
    ticket: {
      title: '使用電子票',
      q1: '什麼是一次性密碼驗證？',
      a1: `當您的連結環境（裝置或瀏覽器等）發生變化時，為防止電子票遭第三者非法使用，本預訂系統將會發送一次性密碼（僅限一次有效的密碼）供您驗證。
  
  於不同的使用環境首次打開電子票時，系統將會發送一次性密碼以供驗證。
  為了確保使用當日可順利使用電子票，建議您可先於活動當日使用的行動裝置或瀏覽器上開啟電子票，查閱內容。
  
  例：
  第一次開啟電子票：A先生在自己的智慧型手機上開啟電子票時，不需進行一次性密碼驗證。
  第二次開啟電子票：A先生在家人的智慧型手機上開啟電子票時，因與第一次開啟電子票的行動裝置不同，將會出現要求完成一次性密碼驗證畫面。須完成驗證。
  此時輸入的電子信箱將會被登錄、固定於系統上。若第三次再以不同的行動裝置開啟電子票時，一次性密碼將會發送至該信箱。建議活動當日可先於信箱內確認是否可收到一次性密碼。`,
      q2: '我突然收到「您的連結環境已變化」訊息。該如何出示電子票？',
      a2: `當您的連結環境發生變化（使用與第一次開啟電子票的不同裝置或瀏覽器開啟電子票）時，須進行一次性密碼驗證。
  若出現上述訊息時，請先輸入您欲收到一次性密碼的電子信箱。※建議輸入可於活動當日現場查看一次性密碼的電子信箱，並確認該信箱是否可收到一次性密碼。
  當您收到郵件後，請輸入正文內的一次性密碼。如密碼無誤即驗證完成，可顯示您的電子票。`,
      q3: '我沒收到一次性密碼的電子郵件。',
      a3: `若超過時間仍未收到一次性密碼郵件，煩請檢查是否有在垃圾信件夾內。若您有限制網域，煩請將「@linktivity.co.jp」加至您的網域許可權。若已嘗試過上述方法仍未收到電子郵件，可能是您輸入的電子信箱有誤。煩請重新正確輸入電子信箱，或嘗試輸入其他的有效電子信箱。`,
      q4: '我可以更改一次性密碼的收件信箱嗎？',
      a4: `恕無法更改一次性密碼的收件信箱。
  一次性密碼一經驗證完成，之後的一次性密碼皆會發送至您登錄的電子信箱內。建議您登錄可於活動當日的行動裝置（當日攜帶的智慧型手機等）上查看電子票的電子信箱。`,
      q5: '我沒購買任何商品卻一直收到一次性密碼的驗證信，這是否為遭盜刷等非法使用？',
      a5: `若您一直收到一次性密碼的驗證信，可能為以下原因：
  ・您將電子票（憑證）轉發給其他同行遊客：
  若您的同行遊客在您開啟電子票、並完成一次性密碼驗證後開啟電子票時，因使用的裝置不同，系統將會向您發送一次性密碼驗證信。
  此時，因您的一次性密碼收件信箱（驗證一次性密碼時登錄的信箱）已被固定，每當您的同行遊客連接電子票時，系統將會依該次數發送一次性密碼驗證信。
  ・非法使用：若您未將電子票轉發給他人，則可能遭人盜用。請您深思熟慮，如有需要煩請重新訂購。`,
      q6: '我收到由不明信箱發送的一次性密碼。',
      a6: `若您收到來自不明信箱發送的一次性密碼，可能為以下原因：
  ・您將電子票（憑證）轉發給其他同行遊客：
  若您在您的同行遊客開啟電子票、並完成一次性密碼驗證後開啟電子票時，因使用的裝置不同，系統將會向您發送一次性密碼驗證信。
  此時，一次性密碼的收件信箱已被固定為該同行遊客的電子信箱（驗證一次性密碼時登錄的信箱），系統將自動發送密碼驗證信至該信箱。若遇此種情況，建議您可先詢問您的同行遊客。
  ・非法使用：若您未將電子票轉發給他人，則可能遭人盜用。請您深思熟慮，如有需要煩請重新訂購。`
    }
  }
};
